<template>
    <div>
        <div class="panel">
            <div class="panel-container show">
                <div class="p-5 panel-content bg-branding" :style="{'background-image': 'url(' + require('@/assets/image/bg_branding.png') + ')', }">
                    <a v-if="!isReportBlock" class="link text-primary fs-lg" @click="returnDashboard">
                        <i class="fas fa-arrow-left mr-2"></i>
                        {{$t('button_link.back')}}
                    </a>
                    <div class="row">
                        <div class="d-flex align-items-center p-5 col-xl-6">
                            <div class="w-100 mr-5 card border">
                                <div class="card-header position-relative border-bottom-0" style="height: 10em">
                                    <div class="bg-img">
                                        <img class="img-fluid brand-logo rounded-circle" :src="getBrandLogo(brandItems.icon)"/>
                                    </div>
                                </div>
                                <div class="p-5 card-body text-center">
                                    <p class="card-title">{{$t('nav.welcome')}}, <b>{{username}}</b></p>
                                    <p class="card-text fw-300 text-muted">{{$t('label.last_login')}}: {{lastlogin}}</p>
                                    <router-link to="/dashboard/change_password" class="btn btn-outline-primary waves-effect waves-themed" :title="$t('nav.changePassword')">
                                        <i class="fas fa-lock mr-2"></i>
                                        <span>{{$t('nav.changePassword')}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center p-5 bg-transparent col-xl-6">
                            <div class="pr-5 mt-5 fs-lg fw-300 b rounded mb-g">
                                <h1 class="mb-g text-dark fs-xxl">
                                    {{brandItems.name}}
                                </h1>
                                <h3 class="mb-g">
                                    {{brandItems.motto}}
                                </h3>
                                <p>
                                    {{brandItems.about}}
                                </p>
                                <div class="mt-5">
                                    <router-link to="/dashboard/my_salon_branding/brand_setup_general" class="mr-3 mb-2 btn btn-outline-primary waves-effect waves-themed" :title="$t('button_link.edit') + $t('subMenu.my_salon_branding')">
                                        <i class="fas fa-pen mr-2"></i>
                                        <span>{{$t('button_link.edit') + $t('subMenu.my_salon_branding')}}</span>
                                    </router-link>
                                    <router-link to="/dashboard/my_salon_tukang" class="mb-2 btn btn-outline-danger waves-effect waves-themed" :title="$t('subMenu.my_salon_tukang')">
                                        <img class="img-fluid img-social mr-2" :src="require('@/assets/image/icon/tukangLogo.png')"/>
                                        <span>{{$t('subMenu.my_salon_tukang')}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired} from './../../assets/js/dashboard/dashboard'
export default {
    name: 'dashboardBrandLanding',
    data(){
        return{
            brandItems: {},
            username: "",
            lastlogin: "",
            isReportBlock: true
        }
    },
    methods: {
        getBrandLogo(src){
            return src
        },
        getBranding(){
            let $vm = this;
            $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_SETTING,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.brandItems = response.data;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        returnDashboard(){
            this.$emit('returnDashboard')
        }
    },
    mounted(){
        let $vm = this
        $vm.lastlogin = moment.unix($vm.$store.state.lastlogin).format($vm.$msg.CST.DATE_TIME_24)
        $vm.username = $vm.$store.state.userName;

        var blockList = JSON.parse(JSON.stringify($vm.$store.state.blockList))
        $vm.isReportBlock = blockList.indexOf("biz.report.*") == -1 ? false : true
        $vm.getBranding()
    },
}
</script>
<style scoped>
.bg-branding{
    background-size: cover;
}
.bg-img{
    background: white;
    height: 10em;
    border-radius: 50%;
    width: 10em;
    margin: auto;
    margin-top: 15% !important;
    /* position: absolute;
    top: 75%;
    left: 50%;
    transform: translate(-50%, -50%); */
    display: flex;
    align-items: center;
    justify-content: center;
}
.brand-logo{
    width: 8em;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, .5);
}
.card-header{
    background-image: radial-gradient( circle 926px at 2.7% 11%,  rgba(17,29,94,.9) 0%, rgba(178,31,102,.9) 90% );
}
.card-body{
    margin-top: 5em;
}
.img-social{
    width: 1.5em;
}
@media only screen and (min-width: px) {
    .bg-img{
        width: 14em;
        height: 14em;
    }
    .brand-logo{
        width: 12em;
    }
}
</style>